import { CloseRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { logEvent } from 'firebase/analytics';
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { analyticsInstanceSelector } from '../../services/GameSlice';
import usePhone from '../../usePhone';
import './phoneNews.css';

// Tells computer players the game now works on phones. It goes away by itself
// after the launch weeks, and for good once someone closes it (in either place).
const SHOW_UNTIL = new Date('2026-12-01T00:00:00Z').getTime();
const CLOSED_KEY = 'news:phone-closed';

const wasClosed = () => {
    try {
        return localStorage.getItem(CLOSED_KEY) === '1';
    } catch (error) {
        return false;
    }
};

// Tagged so phone visits that came from the code show up in analytics.
const qrLink = (place) => `${window.location.origin}/?utm_source=qr&utm_campaign=phone&utm_content=${place}`;

const COPY = {
    start: {
        title: 'Sequence now plays on your phone',
        text: 'Scan to open it on yours. Invite links work on phones too, so friends can join from anywhere.',
    },
    result: {
        title: 'Next game on your phone?',
        text: 'Sequence now plays on phones. Scan to open it on yours.',
    },
};

/** `place` is 'start' (the start-a-game dialog) or 'result' (the game-over dialog). */
const PhoneNews = ({ place = 'start' }) => {
    const phone = usePhone();
    const analytics = useSelector(analyticsInstanceSelector);
    const [closed, setClosed] = useState(wasClosed);
    const visible = !phone && !closed && Date.now() < SHOW_UNTIL;

    useEffect(() => {
        if (visible && analytics) {
            logEvent(analytics, 'phone_news_shown', { place });
        }
    }, [visible, analytics, place]);

    if (!visible) {
        return null;
    }

    const close = () => {
        try {
            localStorage.setItem(CLOSED_KEY, '1');
        } catch (error) { /* private mode: closes for this visit only */ }
        setClosed(true);
        if (analytics) {
            logEvent(analytics, 'phone_news_closed', { place });
        }
    };

    const copy = COPY[place] || COPY.start;
    return (
        <aside className={`phone-news ${place}`} aria-label="New: play on your phone">
            <div className="phone-news-qr">
                <QRCodeSVG value={qrLink(place)} size={place === 'start' ? 76 : 64} level="M" marginSize={0} fgColor="#16201C" bgColor="#FFFFFF" title="QR code that opens Play Sequence on your phone"/>
            </div>
            <div className="phone-news-text">
                <span className="phone-news-tag">New</span>
                <strong>{copy.title}</strong>
                <span>{copy.text}</span>
            </div>
            <IconButton size="small" className="phone-news-close" aria-label="Close" onClick={close}>
                <CloseRounded fontSize="small"/>
            </IconButton>
        </aside>
    );
};

export default PhoneNews;
